import { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Select from "react-select";

import classes from "./ordersReturnFilter.module.scss";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const baseUnits = [
	{ value: 1, label: "g - cc" },
	{ value: 1000, label: "Kg - L" },
	{ value: 10000, label: "Tn - KL" },
];

const OrdersReturnFilter = ({ filters, applyFilter }) => {
	const [defaultUnitFilter, setDefaultUnitFilter] = useState(filters && filters.defaultUnitFilter);
	const [purchaseOrderReturnFilter, setPurchaseOrderFilter] = useState(filters && filters.purchaseOrderReturnFilter);
	const [dateFilter, setDateFilter] = useState(filters && filters.dateFilter);
	const [dateToFilter, setDateToFilter] = useState(filters && filters.dateToFilter);

	const handleCleanFilter = () => {
		applyFilter({
			purchaseOrderReturnFilter: "",
			defaultUnitFilter: 1000,
			dateFilter: "",
			dateToFilter: "",
		});
	};

	const handleApplyFilter = () => {
		applyFilter({
			purchaseOrderReturnFilter,
			defaultUnitFilter,
			dateFilter,
			dateToFilter,
		});
	};

	return (
		<Col md={2} className={classes.filter}>
			<div className={classes.filterTitle}>
				<h4 className={classes.titleH4}>Filtros</h4>
				<hr className={classes.filterHr} />
			</div>

			<div className={classes.divContent}>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>N° Nota de Crédito</span>
					</Col>
					<Col md={12}>
						<Form.Control
							type="text"
							name="order_code"
							placeholder=" "
							value={purchaseOrderReturnFilter ? purchaseOrderReturnFilter : ""}
							onChange={(e) => setPurchaseOrderFilter(e.target.value)}
						/>
					</Col>
				</Row>

				<hr />

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Unidad de Medida</span>
					</Col>
					<Col md={12}>
						<Select
							value={baseUnits && baseUnits.filter((b) => Number(b.value) === Number(defaultUnitFilter))}
							placeholder={<div>Seleccione</div>}
							options={baseUnits ? baseUnits : []}
							onChange={(value) => setDefaultUnitFilter(value.value)}
							components={{ NoOptionsMessage }}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Fecha Ingreso</span>
					</Col>
					<Col md={12}>
						<small>Desde</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={dateFilter}
							onChange={(e) => setDateFilter(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
						/>
					</Col>
					<Col md={12}>
						<small>Hasta</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={dateToFilter}
							onChange={(e) => setDateToFilter(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
						/>
					</Col>
				</Row>
			</div>

			<div className={classes.divFooter}>
				<Button className={classes.buttonClean} onClick={() => handleCleanFilter()}>
					Limpiar
				</Button>

				<Button className={classes.buttonApply} onClick={() => handleApplyFilter()}>
					Aplicar
				</Button>
			</div>
		</Col>
	);
};

export default OrdersReturnFilter;
